export const DEFAULT_LOADING_ITEMS = 3;
